import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-group-class-card',
  template: '<div class="card h-100"><ng-content></ng-content></div>',
  styles: [`
    .card {
      border-radius: 16px;
      overflow: hidden;
      height: 100%;

      &:hover .type-description {
        display: block;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupClassCardComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-card/group-class-card.component.ts